import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import Logo from "../../assets/images/ppp.png";
import { language } from "../../stores/slices/languageSlice";
import { Link } from "react-router-dom";
import Loader from "../menu/Loader";
import { preAuth, setPreAuthDone } from "../../stores/slices/preAuthSlice";
import {
  Email,
  fetchUserLogin,
  loginLoader,
  loginPortalDetails,
  ouathServiceApi,
  resetPrevSession,
  updateIsLoggedin,
  updateLogin,
  updateRememberMeFlag,
  updateUserId,
} from "../../stores/slices/loginSlice";
import { Modal } from "antd";
import style from "./login.module.css";
import Input from "../input/Input";
import validateInput from "../../utilities/validations/validateInput";
import { toast } from "react-toastify";
import FooterLinks from "./FooterLinks/FooterLinks";
import {
  fetchMessages,
  setIsPortalMessage,
} from "../../stores/slices/portalMessagesSlice";
import { fetchLookUp } from "../../stores/slices/lookupSlice";
import {
  fetchAppListsCPR,
  fetchAppListsFAF,
} from "../../stores/slices/applicationsSlice";
import {
  fetchRequiredActionsCPR,
  fetchRequiredActionsFAF,
} from "../../stores/slices/requiredActionsSlice";
import { resetRequiredActions } from "../../stores/slices/requiredActionsSlice";
import {
  fetchClaimList,
  resetClaimList,
} from "../../stores/slices/claimIntake/claimListSlice";
import SuperTokens from 'supertokens-web-js';
import EmailPassword from 'supertokens-web-js/recipe/emailpassword'
import MultiFactorAuth from 'supertokens-web-js/recipe/multifactorauth';
import Passwordless, { clearLoginAttemptInfo, consumeCode, createCode, resendCode } from 'supertokens-web-js/recipe/passwordless';
import Multitenancy from "supertokens-web-js/recipe/multitenancy";
import EmailVerification from "supertokens-web-js/recipe/emailverification";
import Session from "supertokens-web-js/recipe/session";
import { PARTNER_AK_VALUE, PARTNER_AUTH, PARTNER_BROWSER_ID, SUPERTOKEN_API_BASE_PATH, SUPERTOKEN_BASE_URL, SUPERTOKEN_WEBSITE_URL } from "../../constant/Constants";
import CryptoJs from "crypto-js";
import { signIn } from "supertokens-web-js/recipe/emailpassword";
import { getAllSessionsService } from "../../stores/slices/supertokens/allSessionsSlice";
import { portalUserService } from "../../stores/slices/supertokens/portalUserSlice";
import { sessionApi } from "../../stores/slices/supertokens/sessionSlice";
import { metaDataService, setIsAgreedtoTermsService } from "../../stores/slices/supertokens/metaDataSlice";
import { sentMailService } from "../../stores/slices/supertokens/sentMailSlice";
import { secondFactorIdService } from "../../stores/slices/supertokens/secondFactorIdSlice";
import { supertokenRevokeService } from "../../stores/slices/supertokens/supertokenRevokeSlice";
import { memberDataService } from "../../stores/slices/supertokens/memberDataSlice";
import { getJwtToken, getOAuthToken, getPortalUserDetails, getRegistrationTokenPPP } from "../../utilities/API/supertokenServices";
import { fetchLogOut } from "../../stores/slices/generalConfiguration/logOutSlice";
import Cookies from "js-cookie"
import { decrypt, encrypt } from "../../utilities/cryptoService";
import Tooltip from "../btooltip/Tooltip";
import Guide from '../../assets/portalGuide.pdf'
import { caseListDetails } from "../../stores/slices/caseManagement/caseListSlice";


function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [needHelp, setNeedHelp] = useState(false);
  const [screenFlages, setScreenFlages] = useState({
    isLoginScreen: true,
    isMailSent: false,
    isRadioBtnScreen: false,
    isUnVerifiedEmailScreen: false,
    sendOtpStatus: false,
  })
  const [openSessionPopUp, setOpenSessionPopUp] = useState(false)
  const [showLoader, setShowLoader] = useState(false)
  const [isAgreedtoTerms, setIsAgreedtoTerms] = useState(true)
  const [otp, setOtp] = useState({
    isValid: true,
    value: ''
  })
  const [portalUserData, setPortalUserData] = useState({
    PortalType: '',
    ProviderID: ''
  })
  const [signInResponseData, setSignInResponseData] = useState({
    isUnVerifiedEmail: '',
    stEmail: '',
    stId: '',
    stSignInStatus: false,
    signInResponse: '',
  })
  const [metaDataRes, setMetaDataRes] = useState({
    portalID: '',
    isActive: ''
  })
  const [maskedData, setmaskedData] = useState({
    nextFactorsArray: [],
    maskedEmail: "",
    maskedPhone: "",
    phoneNumbersForOTP: "",
    emailsForOTP: "",
  })
  const [stEmailPhone, setStEmailPhone] = useState({
    value: '',
    isValid: false,
  });
  const [loginInfo, setLoginInfo] = useState({
    Email_Address: {
      value: "",
      isValid: true,
    },
    User_Password: {
      value: "",
      isValid: true,
    },
    rememberMe: false
  });
  const selectedLanguage = useSelector(language).Login;
  const loginStatus = useSelector((state) => state.loginSlice);
  const preAuthStore = useSelector((state) => state.preAuthSlice);
  const portalMessage = useSelector((state) => state.portalMessagesSlice);
  const jwtData = useSelector((state) => state.jwtTokenSlice);
  const metaDataSlice = useSelector((state) => state.metaDataSlice);

  useEffect(() => {
    SuperTokens.init({
      appInfo: {
        apiDomain: SUPERTOKEN_BASE_URL,
        websiteDomain: SUPERTOKEN_WEBSITE_URL,
        apiBasePath: SUPERTOKEN_API_BASE_PATH,
        appName: "PARTNER-MFA",
      },
      recipeList: [
        EmailPassword.init(),
        Passwordless.init({
          contactMethod: "EMAIL_OR_PHONE",
        }),
        MultiFactorAuth.init({
          firstFactors: ["emailpassword"],
          secondFactors: ["otp-email", "otp-sms"],
        }),
        EmailVerification.init({
          mode: "REQUIRED", // or "OPTIONAL"
        }),
        Multitenancy.init({
          override: {
            functions: (oI) => {
              return {
                ...oI,
                getTenantId: (input) => {
                  // let tid = localStorage.getItem("tenantId");
                  // return tid === null ? undefined : tid;
                  return "public"
                }
              }
            }
          }
        }),
        Session.init(),
      ],
    });
  }, [])
  const moveToDashboard = () => {
    dispatch(resetClaimList());
    dispatch(resetRequiredActions());
    dispatch(fetchAppListsCPR({ Program: "CPR", EIN: loginStatus.value.EIN, paramData : ""  }));
    dispatch(fetchAppListsFAF({ Program: "FAF", EIN: loginStatus.value.EIN, paramData : ""  }));
    dispatch(caseListDetails({einnumber : loginStatus.value.EIN}))
    dispatch(
      fetchRequiredActionsCPR({ Program: "CPR", EIN: loginStatus.value.EIN })
    );
    dispatch(
      fetchRequiredActionsFAF({ Program: "FAF", EIN: loginStatus.value.EIN })
    );
    dispatch(
      fetchClaimList({
        appID: undefined,
        ein: loginStatus.value.EIN,
        prgData: "CPR",
      })
    );
    dispatch(
      fetchClaimList({
        appID: undefined,
        ein: loginStatus.value.EIN,
        prgData: "FAF",
      })
    );
    // navigate("/dashboard");
  };

  // loginStatus.isLoggedin && moveToDashboard();

  const getPortalMessage = () => {
    // FAF LookUp data
    dispatch(fetchLookUp("FAF"));
    dispatch(fetchMessages());
    dispatch(setPreAuthDone("FAF"));
  };
  const getCPRLookup = () => {
    // CPR LookUp data
    dispatch(fetchLookUp("CPR"));
    dispatch(setPreAuthDone("CPR"));
  };
  preAuthStore.isFAFPreAuthDone && getPortalMessage();
  preAuthStore.isCPRPreAuthDone && getCPRLookup();

  const onChangeForm = (e) => {
    let inputValue = e.target.value;
    let name = e.target.name;
    let fieldValidation = e.target.getAttribute("fieldvalidation");
    let inputValidate = validateInput(inputValue, fieldValidation);
    setLoginInfo((preInfo) => ({
      ...preInfo,
      [name]: {
        value: inputValidate.value,
        isValid: inputValidate.isValid,
      },
    }));
  };
  async function validateForm(e, prevSession = "") {
    // await Session.attemptRefreshingSession()
    e.preventDefault();
    // await Session.attemptRefreshingSession()
    const date = new Date();
    date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
    const expires = date.toUTCString();

    const cookiesEmail = Cookies.get('value')
    const userEmail = loginInfo?.Email_Address?.value?.toLowerCase()
    if (cookiesEmail != undefined && (decrypt(cookiesEmail, "A9fK3Qx7M2L8ZpR4") != userEmail)) {
      // await Session.signOut()
      await deleteAllCookies()
    }
    // document.cookie = `email=${loginInfo.Email_Address.value};expires=${expires};max-age=2592000`;
    // document.cookie = `rememberMeFlag=${loginInfo.rememberMe};expires=${expires};max-age=2592000`;
    if (loginInfo.rememberMe && (cookiesEmail == undefined || decrypt(cookiesEmail, "A9fK3Qx7M2L8ZpR4") != userEmail)) {
    Cookies.set('rememberMeFlag', encrypt(loginInfo.rememberMe, "A9fK3Qx7M2L8ZpR4"), { expires: 30, sameSite: 'Lax' })
    Cookies.set('value', encrypt(userEmail, "A9fK3Qx7M2L8ZpR4"), { expires: 30, sameSite: 'Lax' })
    }
    const rememberMeFlag = Cookies.get('rememberMeFlag')
    const rememberMeCheck = (typeof rememberMeFlag != "undefined" && decrypt(rememberMeFlag, "A9fK3Qx7M2L8ZpR4")) == "true" ? true : false
    dispatch(updateRememberMeFlag(rememberMeCheck))
    let formValidate =
      loginInfo.Email_Address.value != "" &&
      loginInfo.Email_Address.isValid &&
      loginInfo.User_Password.value != "" &&
      loginInfo.User_Password.isValid;
    let stId = ''
    if (formValidate) {
      dispatch(Email(loginInfo.Email_Address.value))
      // storeSupertokens.email = this.state.Email
      setShowLoader(true)
      try {
        const signInResponse = await signIn({
          formFields: [{
            id: "email",
            value: loginInfo.Email_Address.value
          }, {
            id: "password",
            value: CryptoJs.MD5(loginInfo.User_Password.value).toString()
          }]
        })

        if (signInResponse.status == "OK") {
          setSignInResponseData((preState) => ({
            ...preState,
            isUnVerifiedEmail: !signInResponse.user.loginMethods[0].verified,
            stEmail: signInResponse.user.loginMethods[0].email,
            stId: signInResponse.user.id,
            stSignInStatus: true,
            signInResponse,
          }))
          setScreenFlages((prevState) => ({
            ...prevState,
            isUnVerifiedEmailScreen: !signInResponse.user.loginMethods[0].verified,
          }));
          stId = signInResponse.user.id
          // storeSupertokens.userID = signInResponse.user.id;
          dispatch(updateUserId(signInResponse.user.id))
          // storeSupertokens.firstFactorId = signInResponse.user.loginMethods[0].recipeUserId
          // if (signInResponse.user.loginMethods[1] != undefined) {
            // storeSupertokens.secondFactorId = signInResponse.user.loginMethods[1].recipeUserId
          // }

          if (signInResponse.user.loginMethods[0].verified) {
            const sessionData = await dispatch(getAllSessionsService(signInResponse.user.id))
            if (sessionData.payload.length > 1 && false) {
              setOpenSessionPopUp(true)
              setShowLoader(false)
            } else {
              // const _this = this
              if (await Session.doesSessionExist()) {
                let userDetails = await getPortalUserDetails(signInResponse.user.id, getUserDetailsCallBack);
                getUserDetailsCallBack(userDetails)
                if (userDetails.payload) {
                  if (signInResponse.user.loginMethods[1].phoneNumber == undefined || signInResponse.user.loginMethods[1].phoneNumber == "" || signInResponse.user.loginMethods[1].email == undefined || signInResponse.user.loginMethods[1].email == "") {
                    const data = JSON.stringify({
                      id: signInResponse.user.loginMethods[1].recipeUserId,
                      email: userDetails.EmailAddress,
                      phone: typeof userDetails.payload.PhoneNumber != 'undefined' ? userDetails.payload.PhoneNumber.replace(/-/g, "") : '9999988888',
                    })
                    // userDetails.PortalType == "Patient" && await superTokensServices.passworlessUpdate(data)
                  }
                }
                if (typeof userDetails.PortalType != 'undefined') {
                const mfaClaim = await Session.getClaimValue({
                  claim: MultiFactorAuth.MultiFactorAuthClaim
                })
                let metaDataReq = {}
                if (mfaClaim.v) {
                  await dispatch(sessionApi())
                  // superTokensServices.getJwtToken(this.state.Email.trim(), this.jwtResponse)
                  const metaData = await dispatch(metaDataService(stId))
                  if (metaData.payload.res.status = "OK") {
                    metaDataReq = {
                      portalID: metaData.payload?.res.metadata?.PortalUserID,
                      isActive: metaData.payload?.res.metadata?.IsActive == "true",
                      IsAgreedtoTerms: typeof metaData.payload?.res?.metadata?.IsAgreedtoTerms != "undefined" || metaData.payload?.res?.metadata?.IsAgreedtoTerms != '' || metaData.payload?.res?.metadata?.IsAgreedtoTerms == true ? metaData.payload?.res?.metadata?.IsAgreedtoTerms : false
                    }
                  }
                  getJwtToken(loginInfo.Email_Address.value.trim(), "PPP", jwtResponse, metaDataReq)
                  setShowLoader(false)
                } else {
                  // if (this.state.signInResponse.user.loginMethods[1] == undefined) {
                  // if (this.state.signInResponse.user.loginMethods[1].phoneNumber != undefined && this.state.signInResponse.user.loginMethods[1].email != undefined) {
                  const mfaInfo = await MultiFactorAuth.resyncSessionAndFetchMFAInfo()
                  setShowLoader(false)
                  let factorEmails = mfaInfo.emails;
                  let factorPhoneNumbers = mfaInfo.phoneNumbers;

                  let emailsForOTP = (factorEmails["otp-email"] != undefined && factorEmails["otp-email"] != "") ? factorEmails["otp-email"] : factorEmails.emailpassword;
                  let phoneNumbersForOTP = typeof factorPhoneNumbers["otp-phone"][0] != 'undefined' && factorPhoneNumbers["otp-phone"][0].length > 0 ? factorPhoneNumbers["otp-phone"] : ['9999988888'];
                  let isTotpSetup = mfaInfo.factors.alreadySetup.includes("totp");
                  let isOTPEmailSetup = mfaInfo.factors.alreadySetup.includes("otp-email");
                  let isOTPSmsSetup = mfaInfo.factors.alreadySetup.includes("otp-sms");
                  let next = mfaInfo.factors.next;

                  //Email Masking
                  const [username, domain] = emailsForOTP[0] != undefined ? emailsForOTP[0].split("@") : "";
                  // if (username.length <= 2) {
                  //   return username[0] + "*".repeat(username.length - 1) + "@" + domain;
                  // }
                  // const maskedUsername = username[0] + "*".repeat(username.length - 2) + username.slice(-1);
                  const maskLength = emailsForOTP[0] != undefined && Math.floor(username.length / 2);
                  // const maskedUsername = "*".repeat(maskLength) + username.slice(maskLength);
                  const maskedUsername = emailsForOTP[0] != undefined && username.slice(0, maskLength) + "*".repeat(username.length - maskLength);

                  const maskedEmail = emailsForOTP[0] != undefined && maskedUsername + "@" + domain;

                  //Mobile Number Masking
                  const visibleDigits = 4;  // Number of digits to keep visible
                  const maskedLength = phoneNumbersForOTP[0] != undefined ? phoneNumbersForOTP[0].length - visibleDigits : ""

                  // Create the masked phone number
                  const maskedPhone = phoneNumbersForOTP[0] != undefined ? "*".repeat(maskedLength) + phoneNumbersForOTP[0].slice(-visibleDigits) : "";

                  let factorsAllowedToBeSetup = mfaInfo.factors.allowedToSetup;
                  setmaskedData((preState) => ({
                    ...preState,
                    nextFactorsArray: next,
                    emailsForOTP,
                    phoneNumbersForOTP,
                    maskedEmail,
                    maskedPhone
                  }))
                  setScreenFlages((preState) => ({
                    ...preState,
                    isRadioBtnScreen: true,
                    isLoginScreen: false,
                  }))
                }
              }
            }
            }
          } else {
            setScreenFlages((prevState) => ({
              ...prevState,
              isUnVerifiedEmailScreen: !signInResponse.user.loginMethods[0].verified,
              isLoginScreen: false,
            }));
            setShowLoader(false)
          }
        } else if (signInResponse.status === "FIELD_ERROR") {
          signInResponse.formFields.forEach(formField => {
            if (formField.id === "email") {
              // Email validation failed (for example incorrect email syntax).
              toast.error(formField.error)
            }
          })
          setShowLoader(false)
        } else if (signInResponse.status === "WRONG_CREDENTIALS_ERROR") {
          toast.error("Email password combination is incorrect.")
          setShowLoader(false)
        } else if (signInResponse.status === "SIGN_IN_NOT_ALLOWED") {
          // the reason string is a user friendly message
          // about what went wrong. It can also contain a support code which users
          // can tell you so you know why their sign in was not allowed.
          toast.error(signInResponse.reason)
        } else {
          toast.error("Something went wrong")
          setShowLoader(false)
        }
      } catch (error) {
        toast.error(error.message)
        setShowLoader(false)
        return false
      }
    } else {
      setLoginInfo((preState) => ({
        ...preState,
        Email_Address: {
          value: loginInfo.Email_Address.value,
          isValid:
            loginInfo.Email_Address.value != "" &&
              loginInfo.Email_Address.isValid
              ? true
              : false,
        },
        User_Password: {
          value: loginInfo.User_Password.value,
          isValid:
            loginInfo.User_Password.value != "" &&
              loginInfo.User_Password.isValid
              ? true
              : false,
        },
      }));
      toast.error("please fill the mandatory fields");
    }
  }
  const getUserDetailsCallBack = (userDetails) => {
    dispatch(loginPortalDetails(userDetails))
    if (typeof userDetails.PortalType == 'undefined') {
      setShowLoader(false)
      toast.error("Something went wrong, Please try again in a few minutes");
      setScreenFlages((prevState) => ({
        ...prevState,
        sendOtpStatus: false,
        isLoginScreen: true,
        isRadioBtnScreen: false
      }));
    } else {
      let data = {
        EmailAddress: userDetails.EmailAddress,
        EIN: userDetails.EINNumber,
        PortalUserID: userDetails.PortalID,
        PortalType: userDetails.PortalType,
        FirstName: userDetails.UserFirstName,
        LastName: userDetails.UserLastName,
        PhoneNumber: userDetails.PhoneNumber,
        CaseMgtUserID: userDetails.CaseMgtUserID
      }
      dispatch(updateLogin(data))
    }
  }

  const handleActiveSession = async (e, text) => {
    e.persist();
    e.preventDefault();
    // this.setState({
    //   EndSession: e.target.id,
    // },
    //   () => {
    //     this.loginSubmit(e);
    //   });

    if (text == "Old") {
      await Session.signOut()
      dispatch(supertokenRevokeService(signInResponseData.stId))
      setOpenSessionPopUp(false)
      validateForm(e)
    } else {
      setShowLoader(false)
      toast.error("Current session closed successfully")
      setOpenSessionPopUp(false)
      setShowLoader(false)
    }
  }
  const jwtResponse = async (response, metaDataReq) => {
    if (response.status === "OK") {

      try {
        const oAuth = getOAuthToken(response.jwt, "PPP");

        if (oAuth) {
          // setJwtData({ jwt: response.jwt }); // Save the JWT token
          oAuthResponse(oAuth, metaDataReq); // Call OAuth Response
        } else {
          setShowLoader(false)
          throw new Error("Couldn't receive OAuth details");
        }
      } catch (error) {
        toast.error("Unable to login. Please try again in a few minutes");
        setShowLoader(false)
      }
    } else {
      toast.error("Something went wrong");
      setShowLoader(false)
    }
  }

  const oAuthResponse = async (token, metaDataReq) => {
    // if (this.state.PortalType == "Patient") {
    //   const providerId = this.state.ProviderID;
    // dispatch(memberDataService(providerId, patientMemberData))
    // } else {
    if (metaDataReq.isActive) {
      if (!metaDataReq.IsAgreedtoTerms) {
        setIsAgreedtoTerms(metaDataReq.IsAgreedtoTerms)
      } else {
        toast.success('Login Successful');
        navigate("/dashboard");
        moveToDashboard()
        dispatch(updateIsLoggedin(true))
        setIsAgreedtoTerms(true)
      }
    } else {
      toast.error("We’re sorry but you are not able to login with the email address provided. Please call us at 1-866-512-3861 for assistance.");
      setScreenFlages((preState) => ({
        ...preState,
        sendOtpStatus: false,
        isRadioBtnScreen: false,
        isLoginScreen: true,
      }))
      setShowLoader(false)
    }
    // }
  }

  // const patientMemberData =(user)=>{
  //   if (typeof user == 'undefined') {
  //     toast.error("Unable to get user details, Please try after sometime!");
  //     return false;
  //   }
  //   if (metaDataRes.isActive) {
  //     if (!metaDataSlice.IsAgreedtoTerms) {
  //      setIsAgreedtoTerms(metaDataSlice.IsAgreedtoTerms)
  //     } else {
  //       dispatch(updateIsLoggedin(true))
  //       toast.success('Login Successful');
  //       navigate("/dashboard");
  //      setIsAgreedtoTerms(true)
  //       setIsAgreedtoTerms(true)
  //     }
  //   } else {
  //     toast.error("We’re sorry but you are not able to register with the email address provided. Please call us at 877-557-2672 for assistance.");
  //     setScreenFlages((preState)=>({
  //       ...preState,
  //       sendOtpStatus: false,
  //       isRadioBtnScreen: false,
  //       isLoginScreen: true,
  //       showLoader: false
  //     }))
  //     setShowLoader(false)
  //   }
  // }

  const verifyEmail = async () => {
    setShowLoader(true)
    const data = JSON.stringify({
      email: loginInfo.Email_Address.value,
      id: signInResponseData.stId
    })
    const mailSent = await dispatch(sentMailService(data))
    if (mailSent?.payload?.res?.msg == "Mail sent successfully") {
      setScreenFlages((preState) => ({
        ...preState,
        isMailSent: true,
      }))
      setShowLoader(false)
    } else {
      toast.error("Mail Not Sent")
      setShowLoader(false)
    }
  }
  const onChangeOtp = (e) => {
    setOtp({
      value: e.target.value
    })
  }
  const resendOTP = async (e) => {
    e.preventDefault();
    let response = await resendCode();

    if (response.status === "RESTART_FLOW_ERROR") {
      // this can happen if the user has already successfully logged in into
      // another device whilst also trying to login to this one.

      // we clear the login attempt info that was added when the createCode function 
      // was called - so that if the user does a page reload, they will now see the 
      // enter email / phone UI again.
      await clearLoginAttemptInfo();
      toast.error("Login failed. Please try again")
      setShowLoader(false)
    } else {
      // OTP resent successfully.
      toast.success("Your verification code has been sent, please check your selected delivery method for your verification code.")
      setShowLoader(false)
    }
  }
  const verifyOtp = async () => {
    // const refreshSession = await Session.attemptRefreshingSession()
    setShowLoader(true)
    const pattern = /^\d{6}$/
    if (pattern.test(otp.value)) {
      await consumeCode({
        userInputCode: otp.value
      }).then(async (otpVerification) => {
        if (otpVerification.status == "OK") {
          await clearLoginAttemptInfo();
          toast.success("Verification code entered successfully")
          await dispatch(sessionApi())
          const metaData = await dispatch(metaDataService(signInResponseData.stId))
          let metaDataReq = {}
          // if (otpVerification.user.loginMethods[1] != undefined) {
          //   const portalID = metaData?.payload?.res?.status == "OK" ? metaData?.payload?.res?.metadata?.PortalUserID : metaData.portalID
          //   try {
          //     // Dispatch the service
          //     const settingSecondFactorId = await dispatch(
          //       secondFactorIdService({id:otpVerification.user.loginMethods[1].recipeUserId, portalId:portalID})
          //     );

          //     // Check the response and handle success
          //     if (settingSecondFactorId.payload) {
          //       setShowLoader(false);// Return the response value
          //       // return settingSecondFactorId.payload; 
          //     } else {
          //       setShowLoader(false);
          //       toast.error("Couldn't set settingSecondFactorId"); // Trigger error handling
          //     }
          //   } catch (error) {
          //     // Handle errors
          //     toast.error("Error occurred in adding the second factor authentication.");
          //     setShowLoader(false);
          //   }
          // }
          if (metaData?.payload?.res?.status == "OK") {
            dispatch(updateUserId(signInResponseData.stId))
            // loginStatus.value.PortalUserID = metaData?.payload?.res?.metadata?.PortalUserID
            setMetaDataRes({
              portalID: metaData?.payload?.res?.metadata?.PortalUserID,
            })
            metaDataReq = {
              portalID: metaData?.payload?.res?.metadata?.PortalUserID,
              isActive: typeof metaData?.payload?.res?.metadata?.IsActive != "undefined" && metaData?.payload?.res?.metadata?.IsActive == 'false' ? false : true,
              IsAgreedtoTerms: typeof metaData.payload?.res?.metadata?.IsAgreedtoTerms != "undefined" || metaData.payload?.res?.metadata?.IsAgreedtoTerms != '' || metaData.payload?.res?.metadata?.IsAgreedtoTerms == true ? metaData.payload?.res?.metadata?.IsAgreedtoTerms : false
            }
          } else {
            toast.error("Something went wrong")
          }
          getJwtToken(loginInfo.Email_Address.value.trim(), "PPP", jwtResponse, metaDataReq)
        } else if (otpVerification.status == "INCORRECT_USER_INPUT_CODE_ERROR") {
          setShowLoader(false);
          dispatch(loginLoader(false))
          toast.error("The Verification Code you entered does not match. Please try again.")
        } else {
          let otpVerification = await consumeCode({
            userInputCode: otp.value
          });
          if (otpVerification.status == "OK") {
            await clearLoginAttemptInfo();
            toast.success("Verification code entered successfully")
            await dispatch(sessionApi())
            const metaData = await dispatch(metaDataService(signInResponseData.stId))
            let metaDataReq = {}
            // if (otpVerification.user.loginMethods[1] != undefined) {
            //   const portalID = metaData?.payload?.res?.status == "OK" ? metaData?.payload?.res?.metadata?.PortalUserID : metaData?.payload?.res?.portalID
            //   try {
            //     // Dispatch the service
            //     const settingSecondFactorId = await dispatch(
            //       secondFactorIdService(otpVerification.user.loginMethods[1].recipeUserId, portalID)
            //     );


            //     // Check the response and handle success
            //     if (settingSecondFactorId.payload) {
            //       setShowLoader(false);
            //         return  settingSecondFactorId.meta; // Return the response value
            //     } else {
            //       setShowLoader(false);
            //       toast.error("Couldn't set settingSecondFactorId"); // Trigger error handling
            //     }
            //   } catch (error) {
            //     // Handle errors
            //     toast.error("Error occurred in adding the second factor authentication.");
            //     setShowLoader(false);
            //   }
            // }
            if (metaData?.payload?.res?.status == "OK") {
              dispatch(updateUserId(signInResponseData.stId))
              // loginStatus.value.PortalUserID = metaData?.payload?.res?.metadata.PortalUserID
              setMetaDataRes({
                portalID: metaData?.payload?.res?.metadata?.PortalUserID,
              })
              metaDataReq = {
                portalID: metaData.payload?.res.metadata?.PortalUserID,
                isActive: typeof metaData?.payload?.res?.metadata?.IsActive != "undefined" && metaData?.payload?.res?.metadata?.IsActive == 'false' ? false : true,
                IsAgreedtoTerms: typeof metaData.payload?.res?.metadata?.IsAgreedtoTerms != "undefined" || metaData.payload?.res?.metadata?.IsAgreedtoTerms != '' || metaData.payload?.res?.metadata?.IsAgreedtoTerms == true ? metaData.payload?.res?.metadata?.IsAgreedtoTerms : false
              }
            } else {
              toast.error("Something went wrong")
            }

            getJwtToken(loginInfo.Email_Address.value.trim(), "PPP", jwtResponse, metaDataReq)
          } else if (otpVerification.status == "INCORRECT_USER_INPUT_CODE_ERROR") {
            setShowLoader(false);
            dispatch(loginLoader(false))
            toast.error("The Verification Code you entered does not match. Please try again.")
          } else {
            toast.error("We have encountered with an error. Please try again")
            setTimeout(() => {
              window.location.reload(true);
            }, 3000);
          }
        }
      }).catch(async (err) => {
        if (err.status == "401") {
          SuperTokens.init({
            appInfo: {
              apiDomain: SUPERTOKEN_BASE_URL,
              websiteDomain: SUPERTOKEN_WEBSITE_URL,
              apiBasePath: SUPERTOKEN_API_BASE_PATH,
              appName: "LLS-MFA",
            },
            recipeList: [
              EmailPassword.init(),
              Passwordless.init({
                contactMethod: "EMAIL_OR_PHONE",
              }),
              MultiFactorAuth.init({
                firstFactors: ["emailpassword"],
                secondFactors: ["otp-email", "otp-sms"],
              }),
              EmailVerification.init({
                mode: "REQUIRED", // or "OPTIONAL"
              }),
              Multitenancy.init({
                override: {
                  functions: (oI) => {
                    return {
                      ...oI,
                      getTenantId: (input) => {
                        // let tid = localStorage.getItem("tenantId");
                        // return tid === null ? undefined : tid;
                        return "public"
                      }
                    }
                  }
                }
              }),
              Session.init(),
            ],
          });
          await Session.attemptRefreshingSession()
          await consumeCode({
            userInputCode: otp.value
          })
        }
      })
    } else {
      if (otp.value == "") {
        setShowLoader(false);
        toast.error("Please Enter Verification Code")
      } else {
        setShowLoader(false);
        dispatch(loginLoader(false))
        toast.error("The Verification Code you entered does not match. Please try again")
      }
    }
  }
  const sendOTP = async () => {
    setShowLoader(true)
    if (stEmailPhone.value == "otp-email") {
      const email = (maskedData.emailsForOTP != undefined && maskedData.emailsForOTP.length > 0) ? maskedData.emailsForOTP[0] : `${signInResponseData.stEmail}`
      try {
        const sendOtp = await createCode({
          email,
          // phoneNumber: "+917339258365"
        });
        setShowLoader(false)
        if (sendOtp.status = "OK") {
          toast.success('The verification code was sent to your registered email address');
          setScreenFlages((preState) => ({
            ...preState,
            sendOtpStatus: true,
            isRadioBtnScreen: false,
          }))
          setShowLoader(false)
        }
      } catch (error) {
        // toast.error(error)
        // setShowLoader(false)
        return false
      }

    } else if (stEmailPhone.value == "otp-sms" || stEmailPhone.value == "otp-phone") {
      const phone = (maskedData.phoneNumbersForOTP != undefined && maskedData.phoneNumbersForOTP.length > 0) ? maskedData.phoneNumbersForOTP[0] : ""
      const sendOtp = await createCode({
        phoneNumber: phone
      });
      if (sendOtp.status = "OK") {
        toast.success('The verification code was sent to your registered phone number');
        setScreenFlages((preState) => ({
          ...preState,
          sendOtpStatus: true,
          isRadioBtnScreen: false,
        }))
        setShowLoader(false)
      }
    } else {
      toast.error("Please select an option to receive the verification code")
      setShowLoader(false)
    }
  }
  const radioOnClick = (e) => {

    setStEmailPhone({
      value: "otp-email",
      isValid: true
    })
  }
  const needHelpFun = () => {
    setNeedHelp(true);
  };

  const TermsOfUseYes = () => {

    toast.success("Login Successful");
    setIsAgreedtoTerms(true)
    dispatch(setIsAgreedtoTermsService(loginStatus.userID))
    navigate("/dashboard");
    moveToDashboard()
    dispatch(updateIsLoggedin(true))
  };
  const TermsOfUseNo = async (e) => {
    setOpenSessionPopUp(false)
    setIsAgreedtoTerms(true)
    dispatch(fetchLogOut({ BrowserId: PARTNER_BROWSER_ID.ID, metaData: metaDataRes.portalID }, logoutResponse))
    setScreenFlages((preState) => ({
      ...preState,
      isLoginScreen: true,
      sendOtpStatus: false,
      isUnVerifiedEmail: false,
      isRadioBtnScreen: false,
    }))
    // loginStatus.rememberMeFlag != "true" && deleteAllCookies()
    loginStatus?.rememberMeFlag != true && await Session.signOut()
  };
  const logoutResponse = (res) => {
    if (res.ResponseDetails.ResponseCode == "010") {
      getRegistrationTokenPPP();
    }
  }
  useEffect(() => {
    if (metaDataSlice.TermsOfUsePopup) {
      setIsAgreedtoTerms(metaDataSlice.TermsOfUsePopup)
    }
  }, [metaDataSlice.TermsOfUsePopup])
  
  const deleteAllCookies = async () => {
    await Session.signOut()
    document.cookie.split(';').forEach(cookie => {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
    });
    await Session.attemptRefreshingSession()
  }
  const partnerTokenCallback =  (response) => {
      if(response?.response?.data?.statusCode == "401"){
        navigate("/Kill");
      }
    }
  
    const getPartnerToken = async () => {
        await getRegistrationTokenPPP(partnerTokenCallback);
    }

  useEffect(() => {
    getPartnerToken();
    const rememberMeFlag = Cookies.get('rememberMeFlag')
    const cookiesEmail = Cookies.get('value')
    if(typeof rememberMeFlag == "undefined" || typeof cookiesEmail == "undefined"){
      deleteAllCookies()
    }
    // ComponentDidMount logic
    // loginStatus.rememberMeFlag != "true" && deleteAllCookies();
    return () => {
    };
  }, []);
  return (
    <>
      {screenFlages.isLoginScreen && <div
        className={`grid columns-12 gap-6 d-flex justify-content-center align-items-center ${style.header_port} `}
      >
        <div className="intro-y g-col-12 g-col-md-6 g-col-lg-4 mt-8 ">
          <div className="search d-none d-sm-block ">
            <h1
              className={`fw-bolder truncate text-center fw-medium ${style.search_font} `}
            >
              Non-Profit Patient Partner Portal
            </h1>
            <p className="text-center">
              Manage All Your Applications, Claims, & Cases in One Place
            </p>
          </div>
        </div>
        <form onSubmit={validateForm}>
          <div
            className={`${style.basic_container} d-flex justify-content-center `}
          >
            <div className={`${style.basic_pageLeft}`}>
              <div className=" d-flex justify-content-center pt-5">
                <img src={Logo} className={`${style.loginLogo}`} alt="logo" />
              </div>
              <div className="container d-flex justify-content-center ">
                <h2 className={`pt-6 ${style.header_title}`}>Log-In</h2>
              </div>
               <br></br>
              <div className="container d-flex justify-content-center ">
                <div className={`${style.input_fields}`}>
                  <Input
                    type="email"
                    id="EmailAddress"
                    label="Username"
                    name="Email_Address"
                    value={loginInfo.Email_Address.value}
                    onChange={(e) => onChangeForm(e)}
                    isValid={loginInfo.Email_Address.isValid}
                    errorMsg={"Please select or input a valid value"}
                    fieldvalidation="email"
                  />
                </div>
              </div><br></br>
              <div className="container d-flex justify-content-center ">
                <div className={`${style.input_fields}`}>
                  <Input
                    type="password"
                    id="Password"
                    label="Password"
                    name="User_Password"
                    value={loginInfo.User_Password.value}
                    onChange={(e) => onChangeForm(e)}
                    isValid={loginInfo.User_Password.isValid}
                    errorMsg={"Please select or input a valid value"}
                    fieldvalidation="password"
                  />
                </div>
              </div>
              <div className="intro-x d-flex align-items-center text-gray-700 dark-text-gray-600 fs-xs fs-sm-sm justify-content-center p-2 pt-5">
                <div
                  className={`d-flex align-items-center font-color ${style.select_option} `}
                >
                  <div className="">
                    <Link to="/forgetPassword" className="">
                      {selectedLanguage?.forgotPassword}
                    </Link>
                  </div>
                  <div className="">
                    <NavLink onClick={needHelpFun} to="" className="">
                      {selectedLanguage?.needHelp}
                    </NavLink>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-center">
                <Input
                  type="checkbox"
                  id="policyCheckbox"
                  labelPosition="left"
                  name="privacy_policy_checkbox"
                  label={`Remember this device for 30 days`}
                  checked={loginInfo.rememberMe}
                  onClick={(e) => {
                    setLoginInfo((prevState) => ({
                      ...prevState,
                      rememberMe: e.target.checked
                    }))
                  }}
                />
              </div>
              <div
                className={`pt-8 pb-4 d-flex justify-content-center gap-6 pt-8 mb-10 ${style.bottom_button} `}
              >
                <button
                  onClick={validateForm}
                  type="submit"
                  className={`btn ${style.buttons}`}
                >
                  {selectedLanguage?.login}
                </button>

                <Link to={"/register"}>
                  <button className={`btn ${style.buttons_register}`}>
                    {selectedLanguage?.register}
                  </button>
                </Link>
              </div>
            </div>
            <div className={`${style.basic_pageRight}`}>
             <div style={{"paddingTop": "3px"}}>
              <b className="p-1">Non-Profit Patient Partners may include:</b>
              <ul className={`${style.login_list}`}>
                <li>Social Workers who work with a non-profit charitable organization</li>
                <li>Case managers who work with a non-profit charitable organization</li>
                <li>Nurses who work with a non-profit charitable organization</li>
                <li>Financial Counselors who work with a non-profit charitable organization</li>
                <li>Other staff assisting patients who work with a non-profit charitable organization</li>
              </ul>
             </div><br></br>
             <div>
                <b className={`${style.note}`}>Note: This portal is NOT intended for individual patients, family members, pharmacy, or provider staff, even if the health system or hospital is a non-profit. PAF maintains separate portals for these user types. </b>
             </div><br></br>
             <div>
              <p><b>To Register:</b> you must have a valid professional email address, and a valid Federal Tax ID/Employer Identification Number (EIN) of the charitable non-profit organization you represent. Once you submit your registration,
               you will receive an email (typically within five minutes) directing you to a website to create your password. You can then log in and begin using your portal account.</p><br></br>
               <p>Click register, to begin the registration process for the Non-Profit Patient Portal.</p>
             </div>
            </div>
            {/* <FooterLinks path="login" /> */}
          </div>
          {/* end wizard */}
        </form>
        <div className="intro-y g-col-12 g-col-md-4 g-col-xl-3 ms-8 pt-6">
          <Tooltip content={"Information to help you navigate the Non-Profit Patient Partner Portal."}>
                <a href={Guide} target="_blank" rel="noopener noreferrer">
                  <p className={style.contentSize} style={{ fontSize: "16px" }}>
                    <u>{'Portal Guide'}</u>
                  </p>
                </a>
              </Tooltip>
        </div>
      </div>}

      {screenFlages.isRadioBtnScreen && <div className={`columns-12 d-flex justify-content-center align-items-center ${style.header_port}`}>
        <div className="bg-white intro-y g-col-12 g-col-md-6 g-col-lg-4 p-5">
          <p className="color-black fw-medium fs-xl">How would you like to receive your verification code?</p>
          <div className='supertoken_radio pt-2 '>
            {/* <Input
          type="radio"
          id={"otp-phone"}
          label={`Phone`}
          name="contact"
          // checked={''}
          // value={'otp-email'}
          // onChange={}
        /> */}
            <Input
              type="radio"
              id={"otp-email"}
              label={`Email ${maskedData.maskedEmail}`}
              name="contact"
              checked={stEmailPhone.isValid}
              value={'otp-email'}
              onClick={(e) => radioOnClick()}
            />
          </div>
          <div className="pt-4 d-flex justify-content-center">
            <button
              type="submit"
              className={`btn ${style.emailsendBtn}`}
              onClick={async () => {
                loginStatus?.rememberMeFlag != true && await Session.signOut()
                setScreenFlages((preState) => ({ ...preState, isRadioBtnScreen: false, isLoginScreen: true }))
                setStEmailPhone({
                  value: "",
                  isValid: false
                })
              }}
            >
              Cancel
            </button>
            <button
              onClick={sendOTP}
              type="submit"
              className={`btn ms-2 ${style.emailsendBtn}`}
            >
              Send Code
            </button>
          </div>

        </div>
      </div>}
      {screenFlages.isUnVerifiedEmailScreen && <div className={`columns-12 d-flex justify-content-center align-items-center ${style.header_port}`}>
        <div className="bg-white intro-y g-col-12 g-col-md-6 g-col-lg-4 p-5">
          {screenFlages.isMailSent ? <div className='text-center'>
            <h6 class="no-text-decoration color-black" style={{ "font-size": "3vh" }}>We have sent an email to your registered email address</h6>
            <p className="color-black pt-3">Please check your email and click "Verify Email" to gain access to the portal</p>
            <button className={`btn ${style.buttons} mt-5`} onClick={() => {
              setScreenFlages((preState) => ({ ...preState, isLoginScreen: true, isMailSent: false }))
            }}>Back to Login</button>
          </div> : <div className='text-center'>
            <h6 class="no-text-decoration color-black" style={{ "font-size": "3vh" }}>In order to access the portal, you must first verify your email address.</h6>
            <p className="color-black pt-3">Click <b>Resend Verification Email</b> to get a new email sent to the email address on file.</p>
            <div className="d-flex justify-content-center pt-5">
              <a className={`btn ${style.emailsendBtn}`} onClick={() =>
                setScreenFlages((prevState) => ({
                  ...prevState,
                  isUnVerifiedEmailScreen: false,
                  isLoginScreen: true
                }))} > CANCEL </a>
              <button className={`btn ms-2 ${style.widthButton}`} id="login" onClick={verifyEmail}>Resend Verification Email</button><br />
            </div>
          </div>}
        </div>
      </div>}
      {screenFlages.sendOtpStatus && <div className={`columns-12 d-flex justify-content-center align-items-center ${style.header_port}`}>
        <div className="bg-white intro-y g-col-12 g-col-md-6 g-col-lg-4 p-5">
          <div className='text-center'>
            <h6 class="no-text-decoration color-black" style={{ "font-size": "3vh" }}>Enter your verification code here</h6><br />
            <Input
              type="text"
              id="Password"
              label="Enter your verification code here"
              name="otp"
              value={otp.value}
              isValid={true}
              onChange={(e) => onChangeOtp(e)}
              errorMsg={"Enter valid OTP"}
            />
          </div>
          <div className='text-center pt-5'>
            <p className="color-black">Didn't receive your verification code? Click <a className="color-danger" href="#" onClick={resendOTP}>here</a> to resend the code.</p>
          </div>
          <div className="text-center d-flex justify-content-center pt-5">
            <a className={`btn ${style.emailsendBtn}`} onClick={async () => {
              loginStatus?.rememberMeFlag != true && await Session.signOut()
              setScreenFlages((preState) => ({ ...preState, sendOtpStatus: false, isLoginScreen: true }))
              setStEmailPhone({
                value: "",
                isValid: false
              })
            }}> Cancel </a>
            <button className={`btn ${style.emailsendBtn} ms-3`} onClick={verifyOtp}>Submit</button><br />
          </div>
        </div>
      </div>}

      {/* Portal Message */}
      <Modal
        title=""
        open={portalMessage.isLoginPortalMessage}
        cancelButtonProps={{ style: { display: "none" } }}
        onOk={() => {
          dispatch(setIsPortalMessage("login"));
        }}
        maskClosable={false}
        closable={false}
        centered
        width={850}
      >
        <ul style={{ listStyle: "circle" }} className="modal_style">
          {portalMessage.loginPortalMessage.map((data) => {
            return <li>{data}</li>;
          })}
        </ul>
      </Modal>
      <Modal
        title=""
        open={needHelp}
        cancelButtonProps={{ style: { display: "none" } }}
        onOk={() => {
          setNeedHelp(false);
        }}
        maskClosable={false}
        closable={false}
        centered
        width={850}
      >
        <div>
          <p className="mb-6 Ass_info">Technical Assistance and Information</p>
          <p className="pb-6">
            For portal inquiries or technical issues, please contact the Patient
            Advocate Foundation at 1-866-512-3861 and select option 5.
          </p>
          <p
            className="text-center pb-6 "
            style={{ fontSize: "18px", fontWeight: "700" }}
          >
            Portal User System Requirements
          </p>
          <div className="pb-6">
            <div className="row">
              <div className="col-md-6">
                <p className="pb-2">
                  <b>Internet Explorer 11</b>
                </p>
                <p className="pb-2">
                  <b>Edge (All Versions)</b>
                </p>
                <p className="pb-2">
                  <b>Adobe Reader 9 or higher version</b>
                </p>
              </div>
              <div className="col-md-6">
                <p className="pb-2">
                  <b>Firefox 39 or higher</b>
                </p>
                <p className="pb-2">
                  <b>Google Chrome 40 or higher</b>
                </p>
                <p className="pb-2">
                  <b>File size uploads are limited to 2MB</b>
                </p>
              </div>
            </div>
          </div>
        </div>
        <p className="mb-8 pb-6">
          <b>Please note:</b> Cookies must be enabled. Cookies are usually
          enabled but refer to your browser's help documents for instructions on
          how to enable cookies if they are disabled. If cookies are not
          enabled, you won't be able to log in, and will see the log-in page
          repeatedly.
        </p>
        <p>
          Older versions of these browsers, or browsers not listed here, may
          work, however, if you experience any problems, use one of the browsers
          listed above. Each one is free, widely available, and often
          pre-installed on many computers. Also, please note this site may not
          have full functionality when viewed on Internet Explorer or Edge.
        </p>
      </Modal>

      {loginStatus.loader || showLoader ? <Loader /> : null}
      <div className="">
        <Modal
          title=""
          open={openSessionPopUp}
          onOk={(e) => {
            handleActiveSession(e, "Old");
          }}
          onCancel={() => {
            toast.error("Current session closed successfully")
            setOpenSessionPopUp(false)
          }}
          width={800}
          cancelText="No"
          maskClosable={false}
          closeIcon={true}
          okText="Yes"
        >
          <p className="modal_style">
            Please select Yes to close the previous session
          </p>
        </Modal>
      </div>
      <div className="">
        <Modal
          title=""
          open={isAgreedtoTerms == false || isAgreedtoTerms == "false"}
          onOk={(e) => {
            TermsOfUseYes()
          }}
          onCancel={() => {
            TermsOfUseNo()
          }}
          width={800}
          cancelText="CANCEL"
          maskClosable={false}
          closeIcon={true}
          okText=" I AGREE"
        >
          <div>
            <b>
              Please review and agree to our{" "}
              <a
                href="https://www.patientadvocate.org/privacy-policy/web-privacy-policy/"
                className=""
                style={{ color: "#009688" }}
                target="_blank"
              >
                Privacy Policy
              </a>{" "}
              and{" "}
              <a
                href="https://www.patientadvocate.org/terms-of-use/"
                className=""
                style={{ color: "#009688" }}
                target="_blank"
              >
                Terms of Use
              </a>{" "}
              in order to proceed
            </b>
          </div>
        </Modal>
      </div>
    </>
  );
}

export default Login;
